<div class="container p-0">
    <div *ngIf="!subdomain && !garantia10">
        <app-header></app-header>
    </div>
    <router-outlet></router-outlet>
</div>

<div *ngIf="!subdomain">
    <app-footer></app-footer>
</div>